'use client'

import classnames from 'classnames'
import React from 'react'
import styles from './styles.module.css'
import Image, {type StaticImageData} from 'next/image'
import MWDSAvatar from '~/mercuryWebCompat/design-system/MWDSAvatar'

export type TestimonialInfo = {
  testimonial: string | JSX.Element
  name: string
  handle?: string | JSX.Element
  className?: string
  /** If not provided, the initials of the `name` prop will be used */
  src?: StaticImageData
  /** If the user is anonymous, we show a different avatar */
  isAnonymous?: boolean
  /** Ability to customize the background color of the fallback InitialsAvatar component */
  initialsAvatarBackgroundColor?: string
  /** Ability to customize the text color of the fallback InitialsAvatar component */
  initialsAvatarTextColor?: string
  /** Ability to customize the card background */
  cardBackground?: string
}

export function InitialsAvatar({
  isAnonymous,
  textColor,
  backgroundColor,
  name,
}: {
  backgroundColor?: string
  textColor?: string
  name: string
  isAnonymous?: boolean
}) {
  return (
    <MWDSAvatar
      name={isAnonymous ? 'Anonymous' : name}
      className={classnames(styles.initialsAvatar, isAnonymous && styles.anonymous)}
      style={{
        color: textColor,
        background: backgroundColor,
        fontWeight: 400,
      }}
      size="custom"
    />
  )
}

export default function TestimonialCard({
  testimonial,
  name,
  handle,
  src,
  className,
  initialsAvatarBackgroundColor,
  initialsAvatarTextColor,
  isAnonymous,
  cardBackground,
}: TestimonialInfo) {
  return (
    <div
      style={{background: cardBackground}}
      className={classnames(styles.testimonialCard, className)}
    >
      <header className={styles.personInfoContainer}>
        {!src && (
          <InitialsAvatar
            isAnonymous={isAnonymous}
            name={name}
            backgroundColor={initialsAvatarBackgroundColor}
            textColor={initialsAvatarTextColor}
          />
        )}
        {src && <Image alt="" src={src} className={styles.personImage} />}
        <div className={styles.personInfo}>
          <p className={styles.personName}>{name}</p>
          {handle && <p className={styles.personHandle}>{handle}</p>}
        </div>
      </header>
      <blockquote className={styles.testimonial}>{testimonial}</blockquote>
    </div>
  )
}
